import {
  Box,
  Text,
  ThemeColors,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const ResumeCards = styled(Box)`
  width: 100%;
  padding: ${({ theme }) => getThemeSpacing(2, theme)};
  gap: ${({ theme }) => getThemeSpacing(3, theme)};
  position: relative;
  overflow: hidden;
  flex-wrap: wrap;
  border-radius: ${({ theme }) => theme.border_radius.card};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
`

export const ImageBackground = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.12;
`

export const ResumeCard = styled(Box)`
  width: 230px;
  flex-direction: column;
  gap: ${({ theme }) => getThemeSpacing(1, theme)};
  padding: ${({ theme }) => getThemeSpacing(2, theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  background: ${({ theme }) => getThemeColor('white', theme)};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  z-index: 1;
`

export const ResumeCardBadge = styled(Box)<{ color: ThemeColors }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${({ color, theme }) => getThemeColor(color, theme) || color};
`

export const ResumeCardTitle = styled(Text)`
  p {
    font-size: 14px;
    font-weight: 500;
  }
`

export const ResumeCardValue = styled(Text)`
  p {
    font-size: 48px;
    font-weight: 500;
    line-height: 56px;
  }
`
